import React, { useEffect } from "react";
import { LinearProgress } from "@mui/material";
import { Box, Container } from "@mui/system";
import { useNavigate } from "react-router-dom";
import LoginBanner from "../nav/LoginBanner";
import { useNav } from "../../context/NavProvider";
import { useUtils } from "../../context/UtilsProvider";
import { useAuth } from "../../context/AuthProvider";

import IdvOtpLoginCard from "../auth/idv-otp/IdvOtpLogInCard";
import ConfirmOtpCard from "../auth/idv-otp/ConfirmOtpCard";

import ScriptLoader from "../account/ScriptLoader";

function IdvOtpAuthPage() {

  const { setShowFooter } = useNav();
  setShowFooter(false);

  const { setFormState, formState } = useUtils();
  const { useGetAuthUser, authState, authStates } = useAuth();
  const { user, isLoading } = useGetAuthUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (!formState) {
      setFormState({
        phoneNumber: "",
        postcode: "",
        dateOfBirth: "",
      });
    }
  }, [formState, setFormState]);

  if (isLoading) {
    return <LinearProgress />;
  }

  if (user) {
    navigate("/");
    return null;
  }

  return (
    <>
      <ScriptLoader />
      {formState && (
        <>
          <Box sx={{ display: { xs: "none", md: "block" } }}>
            <LoginBanner />
          </Box>
          <Container sx={{ mt: 4, mb: 7, paddingBottom: "350px" }}>
            <Box
              sx={{
                mt: 0,
              }}
            >
              {authState === authStates.signedOut && <IdvOtpLoginCard />}
              {authState === authStates.confirmOtp && <ConfirmOtpCard />}
            </Box>
          </Container>
          {setShowFooter(true)}
        </>
      )}
    </>
  );
}

export default IdvOtpAuthPage;
